import { shallowEqual, useSelector } from "react-redux";
import { ApplicationState } from "./rootReducer";

export function useSelectorShallow<TSelected>(selector: (state: ApplicationState) =>TSelected):TSelected{
    return useSelector(selector, shallowEqual);
}